import produce from 'immer';
import { AnyAction } from 'redux';
import {
  GET_RESERVE_HISTORY_REQUEST,
  GET_RESERVE_HISTORY_SUCCESS,
  GET_RESERVE_HISTORY_FAILURE,
  GET_RESERVE_HISTORY_INITIAL,
} from '../../actions';

export type GetReserveHistoryStateType = {
  isGetReserveHistoryLoading: boolean;
  isGetReserveHistoryLoaded: boolean;
  getReserveHistory: GetReserveHistoryType;
};

type GetReserveHistoryType = {
  result: number;
  data_list: ReserveDataType[];
  visitor_data: VisitorDataType;
};

export type ReserveDataType = {
  data_id: string;
  schedule_id: number;
  companion: number | null;
  schedule_date: string | null;
  start_time: string | null;
  end_time: string | null;
  reservation_fixed_day: number | null;
  reservation_fixed_hours: number | null;
  reservation_fixed_minutes: number | null;
  cancel_abled_day: number | null;
  cancel_abled_hours: number | null;
  cancel_abled_minutes: number | null;
  alternate_label: string | null;
  contents_id: number | null;
  contents_annex_flag: number | null;
  contents_web_show_name: string | null;
  contents_classification: number | null;
  program_id: number | null;
  follow_people_upper: string | null;
  club_equipment_annex_flag: number | null;
  installed_seats_name: string | null;
  club_id: number | null;
  club_annex_flag: number | null;
  club_web_show_name: string | null;
  open_date: string | null;
  telephone_number: string | null;
  post_id: string | null;
  address: string | null;
  addr_buildname: string | null;
  annex_post_id: string | null;
  annex_address: string | null;
  annex_addr_buildname: string | null;
  layout_picture: string | null;
  reserve_time: string | null;
  reserve_time_label: string | null;
  reserve_available_time: string | null;
  reserve_available_time_label: string | null;
  cancel_available_time: string | null;
  cancel_available_time_label: string | null;
};

export type VisitorDataType = {
  visitor_id: string;
  visitor_name: string | null;
  visitor_sei: string | null;
  visitor_mei: string | null;
  // birthday: string;
  // sex: string | null;
  mail_address: string | null;
  contact_telephone: string;
  // post_id: string | null;
  // addr_prefectures: string | null;
  // addr_municipalities: string | null;
  // addr_streetname_number: string | null;
  // addr_buildname_other: string | null;
  // emergency_contact_telephone: string | null;
  // emergency_contact_name: string | null;
  // guardian_firstname: string | null;
  // guardian_secondname: string | null;
};

const initialState: GetReserveHistoryStateType = {
  isGetReserveHistoryLoading: false,
  isGetReserveHistoryLoaded: false,
  getReserveHistory: {
    result: -1,
    data_list: [],
    visitor_data: {
      visitor_id: '',
      visitor_name: '',
      visitor_sei: '',
      visitor_mei: '',
      mail_address: '',
      contact_telephone: '',
    },
  },
};

const getReserveHistoryReducer = (state = initialState, action: AnyAction): GetReserveHistoryStateType => {
  return produce(state, (draft) => {
    const dataState = draft;
    switch (action.type) {
      case GET_RESERVE_HISTORY_REQUEST:
        dataState.isGetReserveHistoryLoading = true;
        dataState.isGetReserveHistoryLoaded = false;
        dataState.getReserveHistory.result = initialState.getReserveHistory.result;
        dataState.getReserveHistory.data_list = initialState.getReserveHistory.data_list;
        dataState.getReserveHistory.visitor_data = initialState.getReserveHistory.visitor_data;
        break;
      case GET_RESERVE_HISTORY_SUCCESS:
        dataState.isGetReserveHistoryLoading = false;
        dataState.isGetReserveHistoryLoaded = true;
        dataState.getReserveHistory.result = action.res.data.result;
        dataState.getReserveHistory.data_list = action.res.data.data_list;
        dataState.getReserveHistory.visitor_data = action.res.data.visitor_data;
        break;
      case GET_RESERVE_HISTORY_FAILURE:
        dataState.isGetReserveHistoryLoading = false;
        dataState.isGetReserveHistoryLoaded = false;
        dataState.getReserveHistory.result = initialState.getReserveHistory.result;
        dataState.getReserveHistory.data_list = initialState.getReserveHistory.data_list;
        dataState.getReserveHistory.visitor_data = initialState.getReserveHistory.visitor_data;
        break;
      case GET_RESERVE_HISTORY_INITIAL:
        dataState.isGetReserveHistoryLoading = false;
        dataState.isGetReserveHistoryLoaded = false;
        dataState.getReserveHistory.result = initialState.getReserveHistory.result;
        dataState.getReserveHistory.data_list = initialState.getReserveHistory.data_list;
        dataState.getReserveHistory.visitor_data = initialState.getReserveHistory.visitor_data;
        break;
      default:
        break;
    }
  });
};

export default getReserveHistoryReducer;
